import {Component} from "@angular/core";
import {ActivityModalEvent, ACTIVITY_STATUS} from "../event/ActivityEvent";
import {ComponentBase} from "../base/ComponentBase";
import {Scilearn} from "../constants";
import {ModalConfig} from "../services/notification/modal.config";
import {EventBus} from "../event/EventBus";
import {RaVersion} from "../services/configuration/ra.version";
import {ContentService, IImageCredit} from "../services/content/content.service";
import {ICredit} from "../api/data-model";
import {filter} from "rxjs/operators";

@Component({
    selector: "credits",
    templateUrl: "./credits.component.html",
    styleUrls: ["./credits.component.scss"]
})

export class CreditsComponent extends ComponentBase {

    private modalType: string = Scilearn.CREDITS_MODAL;
    public activeModal: boolean = false;
    public imageCredits: IImageCredit[];
    public credits: ICredit[];
    public titleCredits: string;

    constructor(private modalConfig:ModalConfig,
                private eventBus:EventBus,
                private contentService: ContentService) {
        super("CreditsComponent");
        this.listenToModalEvents();
    }

    private listenToModalEvents(): void {
        // event filter for user clicking a link to display
        let activitySubscription = this.eventBus.pipe(filter(event => event instanceof ActivityModalEvent)).subscribe((event:ActivityModalEvent) => {
            if (event.status === ACTIVITY_STATUS.modal_open && event.data.type === this.modalType) {
                if (this.isReadingView()) {
                    this.loadCredits();
                }
                this.openModal();
            }
        });

        this.subscriptions.push(activitySubscription);
    }

    public isReadingView(): boolean {
        return !!window.location.hash.match("/reading");
    }

    private loadCredits(): void {
        this.credits = this.contentService.getStoryCredits();
        this.imageCredits = this.contentService.getImageCredits();
        this.titleCredits = this.contentService.getStoryTitleCredits();
    }

    private openModal(): void {
        this.activeModal = true;
    }

    public closeModal(): void {
        this.activeModal = false;
    }

}
